import styled from 'styled-components'
import { colors, media } from 'client/styles'

export const CollapsibleSectionBase = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${colors.white};
  border: 2px solid ${colors.grey4};
  border-radius: 8px;
  padding-block: 20px;
  padding-inline: 20px;
  width: 100%;
  min-width: 240px;

  ${media.mobile} {
    max-width: ${props => (props.fullWidth ? 'unset' : '350px')};
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;

  color: ${colors.grey1};
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 16px;
  color: ${colors.grey2};
  line-height: 150%;
  margin-block-start: 20px;
  width: 100%;
`

export const IconWrapper = styled.div`
  fill: ${colors.grey1};
`
